import { injectable } from '@servicetitan/react-ioc';

import { HttpClient } from '../../common/api/http-client';

export enum UserPhoneCountryCode {
    US = 'us',
    CA = 'ca',
    AU = 'au',
}

export interface UserPhone {
    phone: string;
    countryCode: UserPhoneCountryCode;
}

export interface UserDetails {
    id: number;
    name: string;
    email: string;
    officePhone: UserPhone | null;
    mobilePhone: UserPhone | null;
    userName: string;
    isMfaEnabled: boolean;
}

export class EditUserDto {
    name: string;
    officePhone: UserPhone | null;
    mobilePhone: UserPhone | null;
    userName: string;
    isMfaEnabled?: boolean;

    constructor(data: any) {
        this.name = data.name;
        this.officePhone = data.officePhone;
        this.mobilePhone = data.mobilePhone;
        this.userName = data.userName;
        this.isMfaEnabled = data.isMfaEnabled;
    }
}

export class EditUserPasswordDto {
    oldPassword: string;
    password: string;
    constructor(data: any) {
        this.oldPassword = data.oldPassword;
        this.password = data.password;
    }
}

export interface ValidateUserInfoModel {
    email: string | null;
    mobilePhone: UserPhone | null;
}

@injectable()
export class AccountSettingsApi {
    constructor(private readonly httpClient: HttpClient) {}

    getUserDetails() {
        return this.httpClient.get<UserDetails>('/account', {
            withCredentials: true,
        });
    }

    editUserDetails(dto: EditUserDto) {
        return this.httpClient.put<void, EditUserDto>('/account', dto, {
            withCredentials: true,
        });
    }

    editUserPassword(dto: EditUserPasswordDto) {
        return this.httpClient.patch<void, EditUserPasswordDto>('/account/password', dto, {
            withCredentials: true,
        });
    }

    validateUserInfo(dto: ValidateUserInfoModel) {
        return this.httpClient.post('/account/user/validation', dto, {
            withCredentials: true,
        });
    }
}
